import { createSelector } from 'reselect';

const daemonsList = (state) => {
    return state.daemonsMessage.daemons;
};

export const getCertDaemon = createSelector([daemonsList], daemonsList => {
    return daemonsList.find(item => item.type === 1);
});
